import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect, useRef, useState } from "react";
import Loading, { LoadingLinear } from "@ingka/loading";
export const PublishLoading = memo(function PublishLoading$({ text, loadingLabel = "", periodMs = 2000 }) {
    const [value, setValue] = useState(0);
    const safePeriodMs = Number.isFinite(periodMs) && periodMs > 0 ? periodMs : 1;
    const lastUpdateTimeRef = useRef(0);
    useEffect(() => {
        let rafId = 0;
        const start = performance.now();
        const tick = (now) => {
            const minFrameMs = 25;
            if (now - lastUpdateTimeRef.current < minFrameMs) {
                rafId = requestAnimationFrame(tick);
                return;
            }
            lastUpdateTimeRef.current = now;
            const elapsed = now - start;
            const phase = (2 * Math.PI * elapsed) / safePeriodMs - Math.PI / 2;
            const next = (Math.sin(phase) + 1) * 50;
            const roundedNext = Math.round(next);
            setValue((prev) => (prev === roundedNext ? prev : roundedNext));
            rafId = requestAnimationFrame(tick);
        };
        rafId = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(rafId);
    }, [safePeriodMs]);
    return (_jsx(Loading, { labelPosition: "center", text: text, children: _jsx(LoadingLinear, { loadingLabel: loadingLabel, loadingMax: 100, loadingValue: value }) }));
});
//# sourceMappingURL=PublishLoading.js.map